/* FROSTBYTE+ — ceas in bara de stare, countdown + terminal pe homepage, glitch la intrarea cardurilor in ecran. */
(function () {
  function start() {
    if (!document.body.classList.contains('fb-on')) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    // ceas + timestamp
    var clock = document.querySelector('.js-fb-clock');
    var stamp = document.querySelector('.js-fbh-stamp');
    function now() {
      var d = new Date();
      var t = pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
      if (clock) clock.textContent = t;
      if (stamp) stamp.textContent = pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear() + ' ' + t;
    }
    now(); setInterval(now, 1000);

    // countdown hero
    var hero = document.querySelector('.fbh');
    if (hero) {
      var end = Date.parse(hero.dataset.end || '');
      var box = hero.querySelector('.js-fbh-count'), eta = hero.querySelector('.js-fbh-eta');
      if (!isNaN(end) && end > Date.now()) {
        box.hidden = false; if (eta) eta.hidden = true;
        var D = box.querySelector('.js-d'), H = box.querySelector('.js-h'), M = box.querySelector('.js-m'), S = box.querySelector('.js-s');
        var tick = function () {
          var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
          D.textContent = pad(Math.floor(s / 86400)); H.textContent = pad(Math.floor(s / 3600) % 24);
          M.textContent = pad(Math.floor(s / 60) % 60); S.textContent = pad(s % 60);
        };
        tick(); setInterval(tick, 1000);
      } else if (!isNaN(end) && eta) {
        eta.innerHTML = 'PATCH STATUS: <b>DEPLOYED</b>';
      }

      // terminal care scrie singur
      var term = hero.querySelector('.js-fbh-term');
      if (term && !reduce) {
        var html = term.innerHTML, lines = html.split('\n');
        term.innerHTML = '<span class="cur"></span>';
        var li = 0, out = [];
        var typeLine = function () {
          if (li >= lines.length) return;
          var line = lines[li], plain = line.replace(/<[^>]+>/g, ''), i = 0;
          var dots = plain.indexOf(' ...');
          var cut = dots > -1 ? line.slice(0, line.indexOf(' ...')) : line;
          var step = setInterval(function () {
            i++;
            var partial = cut.replace(/&gt;/g, '>').slice(0, i).replace(/>/g, '&gt;');
            term.innerHTML = out.join('\n') + (out.length ? '\n' : '') + partial + '<span class="cur"></span>';
            if (i >= cut.replace(/&gt;/g, '>').length) {
              clearInterval(step);
              setTimeout(function () {
                out.push(line); li++;
                term.innerHTML = out.join('\n') + '\n<span class="cur"></span>';
                setTimeout(typeLine, 260);
              }, dots > -1 ? 420 : 160);
            }
          }, 28);
        };
        setTimeout(typeLine, 500);
      }
    }

    // glitch o data cand cardul intra in ecran
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target; io.unobserve(el);
          setTimeout(function () { el.classList.add('fb-gin'); setTimeout(function () { el.classList.remove('fb-gin'); }, 700); }, Math.random() * 400);
        });
      }, { threshold: 0.35 });
      document.querySelectorAll('.product-card').forEach(function (c) { io.observe(c); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); });
  else setTimeout(start, 0);
})();
